import React, { Component } from "react";
import { connect } from "react-redux";
import TableData from "./components/TableData";
import UserList from "./components/UserList";
import { StyledCard, StyledContent, StyledHeader } from "../../styles";
import styled from "styled-components";
import {
    setTabSelection,
    getPermissions,
    saveChanges,
    initializeAccessLevels,
    setUserType,
} from "./actions";
import "./components/style.css";
import {
    selectCurrentTab,
    selectPermissions,
    selectAllPermissions,
    selectCurrUsers,
    selectCurrentUserTab,
} from "./selectors";
import {
    Tabs,
    Tab,
    Divider,
    Typography,
    Button,
    Grid,
} from "@material-ui/core";

const TabsBar = styled(Tabs)`
    border: 1px solid black;
    width: fit-content;
    border-radius: 10px;
    background-color: white;
`;
class SecurityConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permissions: false,
            allPermissions: false,
        };
        props.getPermissions();
    }
    componentDidUpdate() {
        if (this.props.permissions !== this.state.permissions)
            this.setState({ permissions: this.props.permissions });
        if (this.props.allPermissions !== this.state.allPermissions)
            this.setState({ allPermissions: this.props.allPermissions });
    }
    render() {
        const { allPermissions, currUserTab } = this.props;

        return (
            <StyledCard>
                <StyledHeader>
                    <Typography variant="h5">Access Levels</Typography>
                </StyledHeader>

                <StyledContent style={{ paddingTop: "0px" }}>
                    <TabsBar
                        indicatorColor="primary"
                        textColor="primary"
                        value={currUserTab}
                        onChange={(event, value) => {
                            this.props.setUserType(value);
                        }}
                        style={{ borderWidth: 0 }}
                    >
                        <Tab label={"Users"} value={"Users"} />
                        <Tab label={"Admin"} value={"Admin"} />

                        <Tab
                            label={"Client/Contractor"}
                            value={"Client/Contractor"}
                        />
                    </TabsBar>
                    <TabsBar
                        indicatorColor="primary"
                        textColor="primary"
                        value={this.props.currentTab}
                        onChange={(event, value) => {
                            this.props.setTabSelection(value);
                        }}
                        style={{ borderWidth: 0 }}
                    >
                        {currUserTab === "Admin" && (
                            <Tab label={"Admin Equipment"} value={"Equipment"} />
                        )}
                        {currUserTab === "Admin" && (
                            <Tab label={"Admin User"} value={"User"} />
                        )}
                        {currUserTab === "Admin" && (
                            <Tab label={"Admin Plant"} value={"Plant"} />
                        )}
                        {currUserTab === "Client/Contractor" && (
                            <Tab label={"Client"} value={"Client"} />
                        )}
                        {currUserTab === "Client/Contractor" && (
                            <Tab label={"Contractor"} value={"Contractor"} />
                        )}
                        {currUserTab === "Users" && (
                            <Tab label={"User - Level 1"} value={"Level 1"} />
                        )}
                        {currUserTab === "Users" && (
                            <Tab label={"User - Level 2"} value={"Level 2"} />
                        )}
                        {currUserTab === "Users" && (
                            <Tab label={"User - Level 3"} value={"Level 3"} />
                        )}
                        {currUserTab === "Users" && (
                            <Tab label={"User - Level 4"} value={"Level 4"} />
                        )}
                    </TabsBar>
                    <br />
                    <Divider />
                    {this.state.permissions ? (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xl={10}>
                                    <TableData
                                        currUserType={this.props.currUserTab}
                                        tableData={this.state.permissions}
                                        setSetting={(
                                            arrIndex,
                                            objIndex,
                                            key,
                                            value
                                        ) => {
                                            let perm = this.state.permissions;
                                            let allPerm = allPermissions;
                                            perm[arrIndex][key] = value;
                                            allPerm[this.props.currentTab][
                                                objIndex
                                            ][key] = value;
                                            this.setState({
                                                permissions: perm,
                                                allPermissions: allPerm,
                                            });
                                        }}
                                    />
                                </Grid>
                                <Grid item xl={2}>
                                    <UserList
                                        usersList={this.props.users}
                                        currLevel={this.props.currentTab}
                                    />
                                </Grid>
                            </Grid>
                            <Button
                                onClick={() => {
                                    this.props.saveChanges(
                                        this.state.allPermissions
                                    );
                                }}
                                color="primary"
                                variant="contained"
                                style={{ marginTop: 24 }}
                            >
                                Save Changes
                            </Button>
                        </>
                    ) : (
                        <Button
                            onClick={() => {
                                this.props.initializeAccessLevels();
                            }}
                            color="primary"
                            variant="contained"
                            style={{ marginTop: 24 }}
                        >
                            {" "}
                            Initialize Access Levels
                        </Button>
                    )}
                </StyledContent>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            currentTab: selectCurrentTab(store),
            permissions: selectPermissions(store),
            allPermissions: selectAllPermissions(store),
            users: selectCurrUsers(store),
            currUserTab: selectCurrentUserTab(store),
        };
    },
    {
        setTabSelection,
        getPermissions,
        saveChanges,
        setUserType,
        initializeAccessLevels,
    }
)(SecurityConfig);
